import Router from 'next/router';
import Svg from 'components/label/Svg';
import Male from '/static/icons/circle-male.svg';
import Female from '/static/icons/circle-female.svg';

// new coveApi[apiName](publicRuntimeConfig.API_HOST, publicRuntimeConfig.ENVIRONMENT, {
//   accessToken: props.accessToken
// });

const UserDropdown = ({
  loggedIn,
  firstName,
  gender,
  onBlur,
  onFocus,
  profileHidden,
  onLogout
}) => {
  if (!loggedIn) {
    return <div />;
  }

  return (
    <div
      className={`navbar-item has-dropdown ${profileHidden ? '' : 'is-active'}`}
      onMouseLeave={onBlur}
      onMouseOver={onFocus}
    >
      <a className="isDesktop-navbar navbar-link has-text-grey">{firstName}</a>
      <a className="isMobile-navbar navbar-link has-text-grey">
        <Svg src={gender == 'M' ? Male : Female} className="svg-48 svg-teal" />
      </a>
      <div className="navbar-dropdown is-right">
        <a
          className="navbar-item"
          onClick={() => {
            Router.push('/user/dashboard');
          }}
        >
          My Cove
        </a>

        <a
          className="navbar-item"
          onClick={() => {
            Router.push('/user/dashboard#policies');
          }}
        >
          Policies
        </a>

        <a
          className="navbar-item"
          onClick={() => {
            Router.push('/user/dashboard#quotes');
          }}
        >
          Quotes
        </a>

        <a
          className="navbar-item"
          onClick={() => {
            Router.push('/user/change-payment');
          }}
        >
          Payment
        </a>

        <hr className="navbar-divider" />
        <a className="navbar-item" onClick={onLogout}>
          Logout
        </a>
      </div>
      <style>{`
      .isMobile-navbar {
        display: none;
      }
        @media screen and (max-width: 480px) {
            .isDesktop-navbar {
              display: none;
            }
            .isMobile-navbar {
              display: initial;
            }
        }
      `}</style>
    </div>
  );
};

export default UserDropdown;
